<!-- <section class="container-fluid no-padding">
    <breadcrumb></breadcrumb>
</section> -->

<div class="main">

    <div class="">

        <div class="col-md-4 hidden-sm hidden-xs "></div>
        <div class="col-md-4 hidden-sm hidden-xs ">
            <div class="">
                <div class="col-md-3 hidden-sm hidden-xs "></div>
                <div class="col-md-4 hidden-sm hidden-xs ">
                </div>
                <div class="col-md-3 hidden-sm hidden-xs "></div>
                <div class="col-md-12 hidden-sm hidden-xs ">
                    <h4 class="" style="margin-top:30px">Coming Soon...</h4>
                </div>
            </div>
        </div>
        <div class="col-md-4 hidden-sm hidden-xs "></div>
    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/knowledgebase.component.html